import SavingsIcon from '@mui/icons-material/Savings';
import { Box, Container, Drawer, Typography, useTheme } from '@mui/material';
import { routes } from 'common/constants';
import BottomNavigation from 'components/mobile/BottomNavigation';
import { PropsWithChildren } from 'react';
import { useHistory } from 'react-router-dom';
import { ProfileMenu } from './Header/ProfileMenu';
import MainNavigation from './MainNavigation';

const styles = {
  container: {
    pt: 2,
    pb: 2,

    maxWidth: {
      xs: 'auto',
      md: 'calc(100% - 480px) !important'
    }
  },
  sidebar: {
    display: {
      xs: 'none',
      sm: 'block'
    },
    width: 240,
    flexShrink: 0,
    [`& .MuiDrawer-paper`]: {
      width: 240,
      boxSizing: 'border-box',
      background: 'transparent',
      boxShadow: 'rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem',
      p: '20px',
      pt: 1,
      borderRight: 'none',
      justifyContent: 'space-between'
    }
  }
};

export interface BaseLayoutProps {
  showNavigation?: boolean;
}

export function SidebarLogo() {
  const theme = useTheme();
  const history = useHistory();
  const handleClick = e => {
    e.preventDefault();
    history.push(routes.home);
  };
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        component={'a'}
        href="/"
        sx={{
          xs: {
            flexGrow: 'initial',
            alignItems: 'center'
          },
          md: {
            flexGrow: 1,
            alignItems: 'end'
          },

          textDecoration: 'none',
          color: theme.palette.primary.dark,
          display: 'flex',

          justifyContent: 'left'
        }}
        onClick={handleClick}
      >
        <SavingsIcon sx={{ xs: { fontSize: 24 }, md: { fontSize: 48 } }} />
        <Typography
          variant="h1"
          sx={{
            xs: { left: '5px', bottom: '2px' },
            md: { left: -10, bottom: 0.5 },
            fontWeight: 700,
            position: 'relative'
          }}
        >
          costman
        </Typography>
      </Box>
    </Box>
  );
}

export function MainSidebar() {
  return (
    <Drawer variant="permanent" open={false} sx={styles.sidebar}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SidebarLogo />
        <MainNavigation />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'left' }}>
        <ProfileMenu />
      </Box>
    </Drawer>
  );
}

export default function BaseLayout({
  showNavigation = true,
  children
}: PropsWithChildren<BaseLayoutProps>) {
  return (
    <Box>
      <main className="content">
        <Container sx={styles.container}>{children}</Container>
      </main>
      {showNavigation && (
        <>
          <MainSidebar />
          <BottomNavigation />
        </>
      )}
    </Box>
  );
}
